import { decodeOwlColoredIntegerSlots, } from './integer-slots.js';
/** Decode an Owl price using the selected ClearType profile, or the combined
 * 20-entry RGB/BGR compatibility lookup when no concrete profile is supplied.
 * Slot matching remains exact.
 */
export const decodeOwlPriceSlots = decodeOwlColoredIntegerSlots;
//# sourceMappingURL=price-slots.js.map